import { SearchFilter, ZonedDateTimeRange } from '@rygen/rygen-ui/model';

import { Manifest } from './Manifest';
import { ManifestSource } from './ManifestSource';
import { ManifestStatus } from './ManifestStatus';

export class ManifestSearchCriteria extends SearchFilter<Manifest> {
  manifestNumber?: string;
  scac?: string;
  ownerNaturalIds: string[] = [];
  locationId?: number;
  locationName?: string;
  locationCode?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  status: ManifestStatus[] = [];
  source: ManifestSource[] = [];
  manifestDate?: ZonedDateTimeRange;

  constructor(opts?: Partial<ManifestSearchCriteria>) {
    super(opts);

    if (opts?.manifestNumber != null) {
      this.manifestNumber = opts.manifestNumber;
    }
    if (opts?.scac != null) {
      this.scac = opts.scac;
    }
    if (opts?.ownerNaturalIds != null) {
      this.ownerNaturalIds = [...opts.ownerNaturalIds];
    }
    if (opts?.locationId != null) {
      this.locationId = opts.locationId;
    }
    if (opts?.locationName != null) {
      this.locationName = opts.locationName;
    }
    if (opts?.locationCode != null) {
      this.locationCode = opts.locationCode;
    }
    if (opts?.city != null) {
      this.city = opts.city;
    }
    if (opts?.state != null) {
      this.state = opts.state;
    }
    if (opts?.postalCode != null) {
      this.postalCode = opts.postalCode;
    }
    if (opts?.country != null) {
      this.country = opts.country;
    }
    if (opts?.status != null) {
      this.status = [...opts.status];
    }
    if (opts?.source != null) {
      this.source = [...opts.source];
    }
    if (opts?.manifestDate != null) {
      this.manifestDate = new ZonedDateTimeRange(opts.manifestDate);
    }

    this.sortField = opts?.sortField ?? 'manifestDate';
    this.sortDirection = opts?.sortDirection ?? 'DESC';
  }

  get isManifestSearchCriteria(): true {
    return true;
  }

  static isManifestSearchCriteria(obj: unknown): obj is ManifestSearchCriteria {
    return (
      !!obj && (obj as ManifestSearchCriteria).isManifestSearchCriteria === true
    );
  }
}
